import { Box, CircularProgress } from "@mui/material";
import { Navigate } from "react-router";
import { DesignerOnboardingGuard, TierGuard } from "../../components/guards";
import { useEffectiveRole } from "../../hooks/useEffectiveRole";
import { useUserContext } from "../../hooks/userContext";
import { Pages } from "../../utils";
import HomeownerBioPage from "../homeowner-bio-page";
import { MyBioPage } from "./index";

export const MyBioRoute = () => {
  const { user, loading } = useUserContext();
  const { isDesigner, isHomeowner, isAdmin } = useEffectiveRole();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress sx={{ color: "#00A06D" }} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to={Pages.LOGIN} replace />;
  }

  if (isDesigner || isAdmin) {
    return (
      <DesignerOnboardingGuard requiresStep="bio">
        <MyBioPage />
      </DesignerOnboardingGuard>
    );
  }

  if (isHomeowner) {
    return (
      <TierGuard
        requiresTier="Guild"
        redirectTo={Pages.HOMEOWNER_MEMBERSHIP_PRICING}
      >
        <HomeownerBioPage />
      </TierGuard>
    );
  }

  return <Navigate to={Pages.DASHBOARD} replace />;
};

export default MyBioRoute;
